import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {USER_LOCALSTORAGE_KEY} from '../../../../../../shared/const/localstorage';
import {updateNoteInStore} from "../../../../slice/groups/set-lessons/set-note/setNote";

interface NoteParams {
    note: string;
    lessonsId: string | undefined;
}

export interface NoteResponse {
    success: boolean;
    note: string;
}

export const fetchNote = createAsyncThunk<NoteResponse, NoteParams>(
    'attendance/fetchNote',
    async ({ note, lessonsId }: NoteParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('Не найден токен в локальном хранилище.');
            }
            const { token } = JSON.parse(authToken);
            const requestData = {
                note: note,
            };

            const response = await axios.put<NoteResponse>(
                `/api/lessons/${lessonsId}/note`,
                requestData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data) {
                thunkAPI.dispatch(updateNoteInStore(response.data.note));
                return response.data;
            } else {
                throw new Error('Ошибка сети');
            }
        } catch (error) {
            return thunkAPI.rejectWithValue('error');
        }
    }
);

// thunkAPI.dispatch(updateNoteInStore(response.data.note));